<template lang="html">
  <div>
    <VqModal
      :name="modalName"
      class="vq-modal-add-public-ip">
      <template v-slot:header>
        <div>
          <h2>Edge {{edge.name}}</h2>
          <h2 class="modal-title"><span class="is-bold">{{ $t('components.ModalAddPublicIp.title') }}</span></h2>
        </div>
      
        <button
          type="button"
          class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
          v-on:click="close">
          <span class="css-icon is-close"></span>
        </button>
      </template>
      <template v-slot:content>
        <Loader v-if="isDataLoading" />
        <div v-else class="forms">
          <form>
            <div class="container has-separator">
              <VqInput
                classes="col-tab-12"
                :label="$t('components.ModalAddPublicIp.form.ip_number')"
                name="ip_nb"
                type="number"
                :errors="errors.ip_number"
                :min="0"
                :tooltip="c('add_public_ip:ip_nb_tooltip')"
                v-model="formData.ip_number"
              />
            </div>
            <div v-if="totalPrice" class="container has-separator">
              <h2 class="modal-title is-bold pa-5">{{ $t('components.modalEditVm.pricing') }}</h2>
              <table class="w-full total-table mt-10">
                <thead>
                  <tr class="is-bold">
                    <th>{{ $t('components.modalEditVm.table.resources') }}</th>
                    <th>{{ $t('components.modalEditVm.table.qty') }}</th>
                    <th>{{ $t('components.modalEditVm.table.price') }}</th>
                    <th>{{ $t('components.modalEditVm.table.total') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ $t('components.modalAddPublicIp.ip_number') }} :</td>
                    <td>{{formData.ip_number}}</td>
                    <td>{{user.company_obj.director_edge_price|price}}€</td>
                    <td>{{ user.company_obj.director_edge_price|price}}€</td>
                  </tr>
                  <tr v-if="totalPrice" class="is-bold">
                    <td>{{ $t('components.modalEditVm.table.total') }} :</td>
                    <td></td>
                    <td></td>
                    <td>{{totalPrice|price}}€
                      <div class="mt-5">
                        (<span v-if="(totalPrice - oldTotalPrice) >= 0">+</span>
                        {{(totalPrice - oldTotalPrice)|price}}€ )
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </template>
      <template v-slot:footer>
        <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.ModalAddPublicIp.cancel') }}</button>
        <div>
          <button
            v-if="$store.state.display_edit && $store.state.otrs_is_active"
            type="button"
            class="button is-small is-gamma"
            @click="submit">{{ $t('components.ModalAddPublicIp.add') }}
          </button>
        </div>
      </template>
    </VqModal>
    <ModalVerificationCode
      v-if="isModalVerificationOpen"
      @verification-code="setVerification"
      @close-verification="isModalVerificationOpen=false"/>
  </div>
</template>

<script lang="js">
import { mapGetters } from 'vuex';
import { eventHubMixin } from '@/mixins/event';
import DIRECTOR from '@/api/director'
import Loader from '@/components/Loader.vue'

import SUPPORT from '@/api/support';
import VqModal from '@/components/VqModal.vue';
import VqInput from '@/components/VqInput.vue';
import ModalVerificationCode from '@/components/ModalVerificationCode.vue';


export default {
  name: 'ModalAddPublicIp',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    VqInput,
    ModalVerificationCode,
    Loader,
  },
  data() {
    return {
      modalName: 'add-public-ip',
      edge: {},
      formData: {},
      errors: {},
      isModalVerificationOpen: false,
      oldTotalPrice: 0,
      isDataLoading: true,
    };
  },
  filters: {
    price: function (value) {
      return (value / 100).toFixed(2)
    }
  },
  mounted() {
    this.onOpenModal(this.modalName, (data) => {
      this.getEdge(data);
      this.initFormErrors();
      this.setOldTotalPrice()
    });
  },
  methods: {
    close() {
      this.emitCloseModal(this.modalName);
    },

    getEdge(data) {
      DIRECTOR.edge({url: data.url, director_host: data.director_host}).then(
        (res) => {
          this.edge = { ...data, ...res.data };
          this.initFormData();
        }
      );
    },
    initFormData() {
      let ip_count = 0
      this.edge.uplinks.forEach(uplink => {
        if (!uplink.is_private) {
          ip_count += parseInt(uplink.total_ip_count)
        }
      })
      this.formData = {
        name: "",
        ip_number: ip_count,
        current_ip_number: ip_count, // pour le calcul serveur du prix
      };
      this.isDataLoading = false
    },

    initFormErrors() {
      this.errors = {
        ip_number: []
      }
    },

    setVerification(data) {
      this.isModalVerificationOpen = false
      this.formData.verification_code = data
      this.submit()
    },
    sendVerificationCode() {
      SUPPORT.verification_code().then((res) => {
        this.isModalVerificationOpen = true
      }),
      (err) => {
        Object.assign(this.errors, err.response.data);
      }
    },

    submit() {
      const method = 'editEdge';
      this.initFormErrors();
      this.formData.name = this.edge.name
      // Prix calculé côté serveur - current_ip_number déjà défini dans initFormData

      SUPPORT[method](this.formData).then(() => {
          this.initFormData();
          this.initFormErrors();
          this.close();
          this.addToast();
        },
        (err) => {
          Object.assign(this.errors, err.response.data);
          this.formData.verification_code = ''
          if (Object.keys(err.response.data).toString() === ['verification_code'].toString()) {
            this.sendVerificationCode()
          }
        },
      );
    },

    addToast() {
      this.emitAddToaster({
        title: this.$t('components.ModalAddPublicIp.toasts.title'),
        text: this.$t('components.ModalAddPublicIp.toasts.content'),
        state: 'success',
      });
    },
    setOldTotalPrice() {
      this.oldTotalPrice = this.setTotalPrice()
    },
    setTotalPrice() {
      return this.formData.ip_number > 5 ? (this.formData.ip_number - 5) * this.user.company_obj.director_edge_price : 0
      // return edgePrice
    },
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    totalPrice() {
      return this.setTotalPrice()
    },

  },
};
</script>

<style scoped lang="scss">
.total-table {
  th {
    text-align: left;
  }
  td, th {
    padding: 5px;
  }
}
</style>
